<div class="timeout-overlay">
  <div class="timeout-card">
    <div class="illustration">
      <div class="icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="clock-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      </div>
    </div>
    <h2 class="timeout-title">Session Expired</h2>
    <p class="timeout-message">
      Your session has timed out due to inactivity. For your security, you have been automatically logged out.
    </p>
    <div class="action-container">
      <button (click)="goToLogin()" class="login-button">
        <span>Log In Again</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="button-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
      </button>
    </div>
  </div>
</div>